import { useQuery, UseQueryOptions } from 'react-query';

import { QueryKeys } from '.';
import { useApi } from '../../context';
import { AxiosUtils } from '../../utils';
import { Guid, MatchingParams } from '../../models';
import { CerebroApiEndpoints } from '../../utils/api';
import { DataRoomLoanApplication } from '../../models';

export function useLoanApplicationQuery(
	dataRoomGuid?: Guid | undefined,
	options?:
		| Omit<UseQueryOptions<DataRoomLoanApplication, unknown, DataRoomLoanApplication, any>, 'queryKey' | 'queryFn'>
		| undefined
) {
	const api = useApi();

	return useQuery(
		QueryKeys.DataRoom.LoanApplication(dataRoomGuid),
		() =>
			AxiosUtils.getResponseData<DataRoomLoanApplication>(
				api.get(CerebroApiEndpoints.DataRooms.LoanApplication(dataRoomGuid))
			),
		options
	);
}
